module.exports = __webpack_public_path__ + "static/media/5f-dark-logo.8f3c373e.png";